import { createIcon } from '../createIcon';

export const TrendUpIconConfig = {
  name: 'TrendUpIcon',
  height: 1024,
  width: 960,
  svgPath: "M960,224 C960,206.3 945.7,192 928,192 L480,192 C462.3,192 448,206.3 448,224 L448,288 C448,305.7 462.3,320 480,320 L741.5,320 L450.3,614.2 L343.7,507.2 C331.2,494.7 310.9,494.6 298.4,507.2 L9.4,796.2 C3.1,802.4 0,810.6 0,818.7 C0,826.9 3.1,835.1 9.4,841.3 L54.7,886.6 C60.9,892.8 69.1,896 77.3,896 C85.5,896 93.7,892.9 99.9,886.6 L320.9,665.6 L427.5,772.6 C440,785.1 460.3,785.2 472.8,772.6 L832,410.5 L831,672 C831,689.7 844.3,704 862,704 L926,704 C943.7,704 960,689.7 960,672 L960,224 Z",
  yOffset: 0,
  xOffset: 0,
  svgClassName: undefined,
};

export const TrendUpIcon = createIcon(TrendUpIconConfig);

export default TrendUpIcon;